import http from "@/api/http";

export const updateUserDidApi = (did: string, privateKey: string) =>
  http.post("/api/did", { did, privateKey });
